import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import 'rxjs/add/operator/switchMap';
import { UtilsService } from '../services/utils.service';
import {Observable} from 'rxjs/Observable';

export interface VerifyYourEmailValidationModalModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-verify-your-email-validation-modal-modal',
  templateUrl: './verify-your-email-validation-modal.component.html',
  styleUrls: ['./verify-your-email-validation-modal.component.css']
})
export class VerifyYourEmailValidationModalComponent extends DialogComponent<VerifyYourEmailValidationModalModel, boolean> implements OnInit, AfterViewInit {
  title: string;
  data: any;
  showVerifyYourEmailValidationModal: boolean;
  isEmailValidated: boolean;
  currentLang: string;
  
  constructor(dialogService: DialogService, private utilsService: UtilsService) {
    super(dialogService);
    this.isEmailValidated = false;
    this.showVerifyYourEmailValidationModal = true;
  }
  
  ngAfterViewInit() {
  	Observable.interval(5000)
			    .takeWhile(() => this.showVerifyYourEmailValidationModal)
			    .subscribe(i => { 
		        	this.showVerifyYourEmailValidationModal = false;
		        	this.close();
	});
  }
  
  ngOnInit() {
  	this.isEmailValidated = this.data.isEmailValidated;
  	this.currentLang = localStorage.getItem('lang') || 'en';
    setTimeout(function () {
            document.getElementsByTagName('body')[0].classList.add('modal-open');
    }, 310);
    if (this.data.message) {
        this.data.message = this.utilsService.decodeHtml(this.data.message);
    } else {
        this.data.message = 'There was an unexpected error.'
            + ' Please try again or contact <a href="mailto:support@openlm.com">support@openlm.com</a> if error persists.';
    }
  }
  
  closeModal() { 
      this.result = true;
      this.close();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/verify-your-email-validation-modal.component.ts